import { CDN_URL } from '../../config.js';

export const HAIR_STYLE_CATEGORIES = [
  {
    "id": "length-and-volume",
    "label": "Length and volume"
  },
  {
    "id": "very-short-hair",
    "label": "Very short hair"
  },
  {
    "id": "short-hair",
    "label": "Short hair"
  },
  {
    "id": "medium-hair",
    "label": "Medium hair"
  },
  {
    "id": "long-hair",
    "label": "Long hair"
  },
  {
    "id": "braids",
    "label": "Braids"
  },
  {
    "id": "hair-buns",
    "label": "Hair buns"
  },
  {
    "id": "ponytails",
    "label": "Ponytails"
  },
  {
    "id": "elaborately-tied-hair",
    "label": "Elaborately-tied hair"
  },
  {
    "id": "big-hair",
    "label": "Big hair"
  },
  {
    "id": "hair-texture",
    "label": "Hair texture"
  },
  {
    "id": "front-of-the-head",
    "label": "Front of the head"
  },
  {
    "id": "top-of-the-head",
    "label": "Top of the head"
  },
  {
    "id": "traditional-chinese",
    "label": "Traditional Chinese"
  }
];

export const HAIR_STYLES = [
  {
    "tag": "very short hair",
    "slug": "very-short-hair",
    "categories": [
      "length-and-volume"
    ]
  },
  {
    "tag": "short hair",
    "slug": "short-hair",
    "categories": [
      "length-and-volume"
    ]
  },
  {
    "tag": "medium hair",
    "slug": "medium-hair",
    "categories": [
      "length-and-volume"
    ]
  },
  {
    "tag": "long hair",
    "slug": "long-hair",
    "categories": [
      "length-and-volume"
    ]
  },
  {
    "tag": "very long hair",
    "slug": "very-long-hair",
    "categories": [
      "length-and-volume"
    ]
  },
  {
    "tag": "absurdly long hair",
    "slug": "absurdly-long-hair",
    "categories": [
      "length-and-volume"
    ]
  },
  {
    "tag": "big hair",
    "slug": "big-hair",
    "categories": [
      "length-and-volume"
    ]
  },
  {
    "tag": "buzz cut",
    "slug": "buzz-cut",
    "categories": [
      "very-short-hair"
    ]
  },
  {
    "tag": "crew cut",
    "slug": "crew-cut",
    "categories": [
      "very-short-hair"
    ]
  },
  {
    "tag": "pixie cut",
    "slug": "pixie-cut",
    "categories": [
      "very-short-hair"
    ]
  },
  {
    "tag": "bob cut",
    "slug": "bob-cut",
    "categories": [
      "short-hair"
    ]
  },
  {
    "tag": "inverted bob",
    "slug": "inverted-bob",
    "categories": [
      "short-hair"
    ]
  },
  {
    "tag": "bowl cut",
    "slug": "bowl-cut",
    "categories": [
      "short-hair"
    ]
  },
  {
    "tag": "undercut",
    "slug": "undercut",
    "categories": [
      "short-hair"
    ]
  },
  {
    "tag": "flattop",
    "slug": "flattop",
    "categories": [
      "short-hair"
    ]
  },
  {
    "tag": "short hair with long locks",
    "slug": "short-hair-with-long-locks",
    "categories": [
      "short-hair"
    ]
  },
  {
    "tag": "wolf cut",
    "slug": "wolf-cut",
    "categories": [
      "medium-hair"
    ]
  },
  {
    "tag": "hime cut",
    "slug": "hime-cut",
    "categories": [
      "long-hair",
      "front-of-the-head"
    ]
  },
  {
    "tag": "braided bangs",
    "slug": "braided-bangs",
    "categories": [
      "braids"
    ]
  },
  {
    "tag": "side braid",
    "slug": "side-braid",
    "categories": [
      "braids"
    ]
  },
  {
    "tag": "crown braid",
    "slug": "crown-braid",
    "categories": [
      "braids"
    ]
  },
  {
    "tag": "braided hair rings",
    "slug": "braided-hair-rings",
    "categories": [
      "braids",
      "traditional-chinese"
    ]
  },
  {
    "tag": "multiple braids",
    "slug": "multiple-braids",
    "categories": [
      "braids"
    ]
  },
  {
    "tag": "twin braids",
    "slug": "twin-braids",
    "categories": [
      "braids"
    ]
  },
  {
    "tag": "low twin braids",
    "slug": "low-twin-braids",
    "categories": [
      "braids"
    ]
  },
  {
    "tag": "quad braids",
    "slug": "quad-braids",
    "categories": [
      "braids"
    ]
  },
  {
    "tag": "rope braid",
    "slug": "rope-braid",
    "categories": [
      "braids"
    ]
  },
  {
    "tag": "cornrows",
    "slug": "cornrows",
    "categories": [
      "braids"
    ]
  },
  {
    "tag": "dreadlocks",
    "slug": "dreadlocks",
    "categories": [
      "braids"
    ]
  },
  {
    "tag": "braided dreadlocks",
    "slug": "braided-dreadlocks",
    "categories": [
      "braids"
    ]
  },
  {
    "tag": "low-braided long hair",
    "slug": "low-braided-long-hair",
    "categories": [
      "braids"
    ]
  },
  {
    "tag": "half up braid",
    "slug": "half-up-braid",
    "categories": [
      "braids"
    ]
  },
  {
    "tag": "half up half down braid",
    "slug": "half-up-half-down-braid",
    "categories": [
      "braids"
    ]
  },
  {
    "tag": "braided ponytail",
    "slug": "braided-ponytail",
    "categories": [
      "braids"
    ]
  },
  {
    "tag": "braided bun",
    "slug": "braided-bun",
    "categories": [
      "hair-buns"
    ]
  },
  {
    "tag": "bun with braided base",
    "slug": "bun-with-braided-base",
    "categories": [
      "hair-buns"
    ]
  },
  {
    "tag": "single hair bun",
    "slug": "single-hair-bun",
    "categories": [
      "hair-buns"
    ]
  },
  {
    "tag": "double bun",
    "slug": "double-bun",
    "categories": [
      "hair-buns",
      "traditional-chinese"
    ]
  },
  {
    "tag": "very low bun",
    "slug": "very-low-bun",
    "categories": [
      "hair-buns"
    ]
  },
  {
    "tag": "cone hair bun",
    "slug": "cone-hair-bun",
    "categories": [
      "hair-buns"
    ]
  },
  {
    "tag": "hair rings",
    "slug": "hair-rings",
    "categories": [
      "hair-buns"
    ]
  },
  {
    "tag": "single hair ring",
    "slug": "single-hair-ring",
    "categories": [
      "hair-buns"
    ]
  },
  {
    "tag": "quad hair rings",
    "slug": "quad-hair-rings",
    "categories": [
      "hair-buns"
    ]
  },
  {
    "tag": "triangle hair bun with corners toward head",
    "slug": "triangle-hair-bun-with-corners-toward-head",
    "categories": [
      "hair-buns"
    ]
  },
  {
    "tag": "half updo",
    "slug": "half-updo",
    "categories": [
      "ponytails"
    ]
  },
  {
    "tag": "one side up",
    "slug": "one-side-up",
    "categories": [
      "ponytails"
    ]
  },
  {
    "tag": "two side up",
    "slug": "two-side-up",
    "categories": [
      "ponytails"
    ]
  },
  {
    "tag": "low-tied long hair",
    "slug": "low-tied-long-hair",
    "categories": [
      "ponytails"
    ]
  },
  {
    "tag": "multi-tied hair",
    "slug": "multi-tied-hair",
    "categories": [
      "ponytails"
    ]
  },
  {
    "tag": "folded ponytail",
    "slug": "folded-ponytail",
    "categories": [
      "ponytails"
    ]
  },
  {
    "tag": "front ponytail",
    "slug": "front-ponytail",
    "categories": [
      "ponytails"
    ]
  },
  {
    "tag": "high ponytail",
    "slug": "high-ponytail",
    "categories": [
      "ponytails"
    ]
  },
  {
    "tag": "low ponytail",
    "slug": "low-ponytail",
    "categories": [
      "ponytails"
    ]
  },
  {
    "tag": "short ponytail",
    "slug": "short-ponytail",
    "categories": [
      "ponytails"
    ]
  },
  {
    "tag": "side ponytail",
    "slug": "side-ponytail",
    "categories": [
      "ponytails"
    ]
  },
  {
    "tag": "high side ponytail",
    "slug": "high-side-ponytail",
    "categories": [
      "ponytails"
    ]
  },
  {
    "tag": "short side ponytail",
    "slug": "short-side-ponytail",
    "categories": [
      "ponytails"
    ]
  },
  {
    "tag": "topknot",
    "slug": "topknot",
    "categories": [
      "ponytails"
    ]
  },
  {
    "tag": "twintails",
    "slug": "twintails",
    "categories": [
      "ponytails"
    ]
  },
  {
    "tag": "low twintails",
    "slug": "low-twintails",
    "categories": [
      "ponytails"
    ]
  },
  {
    "tag": "short twintails",
    "slug": "short-twintails",
    "categories": [
      "ponytails"
    ]
  },
  {
    "tag": "bow-shaped hair",
    "slug": "bow-shaped-hair",
    "categories": [
      "elaborately-tied-hair"
    ]
  },
  {
    "tag": "afro",
    "slug": "afro",
    "categories": [
      "big-hair"
    ]
  },
  {
    "tag": "beehive hairdo",
    "slug": "beehive-hairdo",
    "categories": [
      "big-hair"
    ]
  },
  {
    "tag": "pompadour",
    "slug": "pompadour",
    "categories": [
      "big-hair"
    ]
  },
  {
    "tag": "curly hair",
    "slug": "curly-hair",
    "categories": [
      "hair-texture"
    ]
  },
  {
    "tag": "flipped hair",
    "slug": "flipped-hair",
    "categories": [
      "hair-texture"
    ]
  },
  {
    "tag": "drill hair",
    "slug": "drill-hair",
    "categories": [
      "hair-texture"
    ]
  },
  {
    "tag": "twin drills",
    "slug": "twin-drills",
    "categories": [
      "hair-texture"
    ]
  },
  {
    "tag": "single drill",
    "slug": "single-drill",
    "categories": [
      "hair-texture"
    ]
  },
  {
    "tag": "hair flaps",
    "slug": "hair-flaps",
    "categories": [
      "hair-texture"
    ]
  },
  {
    "tag": "messy hair",
    "slug": "messy-hair",
    "categories": [
      "hair-texture"
    ]
  },
  {
    "tag": "pointy hair",
    "slug": "pointy-hair",
    "categories": [
      "hair-texture"
    ]
  },
  {
    "tag": "hair horns",
    "slug": "hair-horns",
    "categories": [
      "hair-texture"
    ]
  },
  {
    "tag": "ringlets",
    "slug": "ringlets",
    "categories": [
      "hair-texture"
    ]
  },
  {
    "tag": "spiked hair",
    "slug": "spiked-hair",
    "categories": [
      "hair-texture"
    ]
  },
  {
    "tag": "straight hair",
    "slug": "straight-hair",
    "categories": [
      "hair-texture"
    ]
  },
  {
    "tag": "wavy hair",
    "slug": "wavy-hair",
    "categories": [
      "hair-texture"
    ]
  },
  {
    "tag": "kinky hair",
    "slug": "kinky-hair",
    "categories": [
      "hair-texture"
    ]
  },
  {
    "tag": "kishimen hair",
    "slug": "kishimen-hair",
    "categories": [
      "hair-texture"
    ]
  },
  {
    "tag": "arched bangs",
    "slug": "arched-bangs",
    "categories": [
      "front-of-the-head"
    ]
  },
  {
    "tag": "asymmetrical bangs",
    "slug": "asymmetrical-bangs",
    "categories": [
      "front-of-the-head"
    ]
  },
  {
    "tag": "bangs pinned back",
    "slug": "bangs-pinned-back",
    "categories": [
      "front-of-the-head"
    ]
  },
  {
    "tag": "blunt bangs",
    "slug": "blunt-bangs",
    "categories": [
      "front-of-the-head"
    ]
  },
  {
    "tag": "center-flap bangs",
    "slug": "center-flap-bangs",
    "categories": [
      "front-of-the-head"
    ]
  },
  {
    "tag": "crossed bangs",
    "slug": "crossed-bangs",
    "categories": [
      "front-of-the-head"
    ]
  },
  {
    "tag": "wispy bangs",
    "slug": "wispy-bangs",
    "categories": [
      "front-of-the-head"
    ]
  },
  {
    "tag": "choppy bangs",
    "slug": "choppy-bangs",
    "categories": [
      "front-of-the-head"
    ]
  },
  {
    "tag": "diagonal bangs",
    "slug": "diagonal-bangs",
    "categories": [
      "front-of-the-head"
    ]
  },
  {
    "tag": "fanged bangs",
    "slug": "fanged-bangs",
    "categories": [
      "front-of-the-head"
    ]
  },
  {
    "tag": "short bangs",
    "slug": "short-bangs",
    "categories": [
      "front-of-the-head"
    ]
  },
  {
    "tag": "long bangs",
    "slug": "long-bangs",
    "categories": [
      "front-of-the-head"
    ]
  },
  {
    "tag": "hair between eyes",
    "slug": "hair-between-eyes",
    "categories": [
      "front-of-the-head"
    ]
  },
  {
    "tag": "hair over one eye",
    "slug": "hair-over-one-eye",
    "categories": [
      "front-of-the-head"
    ]
  },
  {
    "tag": "hair over eyes",
    "slug": "hair-over-eyes",
    "categories": [
      "front-of-the-head"
    ]
  },
  {
    "tag": "parted bangs",
    "slug": "parted-bangs",
    "categories": [
      "front-of-the-head"
    ]
  },
  {
    "tag": "middle part",
    "slug": "middle-part",
    "categories": [
      "front-of-the-head"
    ]
  },
  {
    "tag": "double-parted bangs",
    "slug": "double-parted-bangs",
    "categories": [
      "front-of-the-head"
    ]
  },
  {
    "tag": "curtained hair",
    "slug": "curtained-hair",
    "categories": [
      "front-of-the-head"
    ]
  },
  {
    "tag": "swept bangs",
    "slug": "swept-bangs",
    "categories": [
      "front-of-the-head"
    ]
  },
  {
    "tag": "colored bangs",
    "slug": "colored-bangs",
    "categories": [
      "front-of-the-head"
    ]
  },
  {
    "tag": "hair intakes",
    "slug": "hair-intakes",
    "categories": [
      "front-of-the-head"
    ]
  },
  {
    "tag": "single hair intake",
    "slug": "single-hair-intake",
    "categories": [
      "front-of-the-head"
    ]
  },
  {
    "tag": "sidelocks",
    "slug": "sidelocks",
    "categories": [
      "front-of-the-head"
    ]
  },
  {
    "tag": "asymmetrical sidelocks",
    "slug": "asymmetrical-sidelocks",
    "categories": [
      "front-of-the-head"
    ]
  },
  {
    "tag": "drill sidelocks",
    "slug": "drill-sidelocks",
    "categories": [
      "front-of-the-head"
    ]
  },
  {
    "tag": "low-tied sidelocks",
    "slug": "low-tied-sidelocks",
    "categories": [
      "front-of-the-head"
    ]
  },
  {
    "tag": "sidelocks tied back",
    "slug": "sidelocks-tied-back",
    "categories": [
      "front-of-the-head"
    ]
  },
  {
    "tag": "single sidelock",
    "slug": "single-sidelock",
    "categories": [
      "front-of-the-head"
    ]
  },
  {
    "tag": "ahoge",
    "slug": "ahoge",
    "categories": [
      "top-of-the-head"
    ]
  },
  {
    "tag": "heart ahoge",
    "slug": "heart-ahoge",
    "categories": [
      "top-of-the-head"
    ]
  },
  {
    "tag": "huge ahoge",
    "slug": "huge-ahoge",
    "categories": [
      "top-of-the-head"
    ]
  },
  {
    "tag": "antenna hair",
    "slug": "antenna-hair",
    "categories": [
      "top-of-the-head"
    ]
  },
  {
    "tag": "heart antenna hair",
    "slug": "heart-antenna-hair",
    "categories": [
      "top-of-the-head"
    ]
  },
  {
    "tag": "comb over",
    "slug": "comb-over",
    "categories": [
      "top-of-the-head"
    ]
  },
  {
    "tag": "hair pulled back",
    "slug": "hair-pulled-back",
    "categories": [
      "top-of-the-head"
    ]
  },
  {
    "tag": "hair slicked back",
    "slug": "hair-slicked-back",
    "categories": [
      "top-of-the-head"
    ]
  },
  {
    "tag": "parted hair",
    "slug": "parted-hair",
    "categories": [
      "top-of-the-head"
    ]
  },
  {
    "tag": "mohawk",
    "slug": "mohawk",
    "categories": [
      "top-of-the-head"
    ]
  }
];

export const hairStyleImageUrl = (slug) => `${CDN_URL}/data/hair/hair_images/${slug}_small.webp`;
